import myapi from '../../api/index.js'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    // 图片上传
    upload: (context, file, progress) => {
      return myapi.upload(file, progress)
    },
    // 直播提交
    liveSub: (context, data) => {
      return myapi.liveSub(data)
    },
    // 直播编辑提交
    subEditLive: (context, data) => {
      return myapi.subEditLive(data)
    }
  }
}
